var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9334 9.42168C10.9334 6.50697 13.2023 4.14316 16 4.14316C18.7978 4.14316 21.0667 6.50697 21.0667 9.42168V14.5018C21.0667 17.4165 18.7978 19.7803 16 19.7803C13.2023 19.7803 10.9334 17.4165 10.9334 14.5018V9.42168ZM16 2C12.0662 2 8.87622 5.32334 8.87622 9.42168V14.5018C8.87622 18.6001 12.0662 21.9234 16 21.9234C19.9339 21.9234 23.1238 18.6001 23.1238 14.5018V9.42168C23.1238 5.32334 19.9339 2 16 2ZM6.05714 13.5282C6.05714 12.9364 5.59664 12.4567 5.02857 12.4567C4.46051 12.4567 4 12.9364 4 13.5282C4 20.0724 8.82507 25.4413 14.9714 25.9847V27.8568H9.90479C9.33673 27.8568 8.87622 28.3366 8.87622 28.9284C8.87622 29.5202 9.33673 30 9.90479 30H22.0953C22.6633 30 23.1238 29.5202 23.1238 28.9284C23.1238 28.3366 22.6633 27.8568 22.0953 27.8568H17.0286V25.9847C23.1749 25.4413 28 20.0724 28 13.5282C28 12.9364 27.5395 12.4567 26.9714 12.4567C26.4034 12.4567 25.9429 12.9364 25.9429 13.5282C25.9429 19.2497 21.4918 23.8868 16 23.8868C10.5082 23.8868 6.05714 19.2497 6.05714 13.5282Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.05b77fc8.svg";
export { ForwardRef as ReactComponent };